/** MUI spacing value (1 = 8px) */
export const fieldsSpacing = 3
